import { render, staticRenderFns } from "./TheContainerAdmin.vue?vue&type=template&id=4bb019ea&scoped=true&"
import script from "./TheContainerAdmin.vue?vue&type=script&lang=js&"
export * from "./TheContainerAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TheContainerAdmin.vue?vue&type=style&index=0&id=4bb019ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb019ea",
  null
  
)

export default component.exports